import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [
    ds.input.select.single.Component,
    ds.input.select.multiple.Component,
  ],
  selector: 'atn-inline-enum-input',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @default undefined
   */
  public readonly labelSg = ngCore.input<string>(undefined, { alias: 'label' })

  /** @see {@link ds.input.select.single.Component._requiredSg} */
  public readonly requiredSg = ngCore.input<boolean>(false, {
    alias: 'required',
  })

  /**
   * @default undefined
   * @see {@link ents.core.dms.data.Value.Type.Enum.Inline}
   */
  public readonly enumSg = ngCore.input<
    ents.core.dms.data.Value.Type.Enum.Inline | undefined
  >(undefined, {
    alias: 'enum',
  })

  /**
   * @default undefined
   * @see {@link ents.core.dms.data.Value.Type.Enum.Inline}
   */
  public readonly valueSg = ngCore.model<unknown>(undefined, {
    alias: 'value',
  })

  /** Converting to list of unknown values since ds-multiselect component expects an array of unknown values */
  public readonly multiSelectValueSg = ngCore.computed(
    (value = this.valueSg(), _enum = this.enumSg()) =>
      _enum?.inlineEnum.isMultiselect
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.List,
          )
        : undefined,
  )

  /**
   * Converts {@link ents.core.common.value.types.Enum.entries} into an array of
   * {@link ds.input.select.models.Item} for use in the select dropdown
   *
   * @default []
   */
  public enumItemsSg = ngCore.computed<readonly ds.input.select.models.Item[]>(
    (enumeration = this.enumSg()) =>
      enumeration?.inlineEnum.entries.map(({ id, name }) => ({
        label: name,
        value: id,
      })) ?? [],
  )
}
